import { call, put, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify";
// Crypto Redux States
import { ADD_ACTIVITY_FOLLOW_UP, ADD_ACTIVITY_PROJECT_FOLLOW_UP, ADD_CONTACT_ACTIVITY_FOLLOW_UP, ADD_PROJECT_LEAD_CALLLOG, ADD_PROJECT_LEAD_EMAILLOG, ADD_PROJECT_LEAD_FOLLOW, ADD_PROJECT_LEAD_NOTE, GET_ACTIVITY_FOLLOW_UP, GET_ACTIVITY_PROJECT_FOLLOW_UP, GET_CONTACT_ACTIVITY_FOLLOW_UP, GET_PROJECT_LEAD_ALL_ACT, GET_PROJECT_LEAD_CALLLOG, GET_PROJECT_LEAD_EMAILLOG, GET_PROJECT_LEAD_FOLLOW, GET_PROJECT_LEAD_NOTE } from "./actionTypes"

import { getActivityFollowUpApi, getActivityProjectFollowUpApi, getContactActivityFollowUpApi, getProjectAllActUrl, getProjectLeadCallLogUrl, getProjectLeadEmailLogUrl, getProjectLeadFollowUrl, getProjectLeadNoteUrl, postActivityFollowUpApi, postActivityProjectFollowUpApi, postContactActivityFollowUpApi, PostProjectLeadCallLog1Url, PostProjectLeadCallLog2Url, PostProjectLeadCallLog3Url, PostProjectLeadEmailLog1Url, PostProjectLeadEmailLog2Url, PostProjectLeadEmailLog3Url, postProjectLeadFollowUrl, PostProjectLeadNoteUrl } from '../../helpers/backend_helper'

import { addActivityFollowUpFail, addActivityFollowUpSuccess, addActivityProjectFollowUpFail, addActivityProjectFollowUpSuccess, addContactActivityFollowUpFail, addProjectLeadCallLogFail, addProjectLeadCallLogSuccess, addProjectLeadEmailLogFail, addProjectLeadEmailLogSuccess, addProjectleadFollowUpFail, addProjectleadFollowUpSuccess, addProjectLeadNoteFail, addProjectLeadNoteSuccess, getActivityFollowUpFail, getActivityFollowUpSuccess, getActivityProjectFollowUpFail, getActivityProjectFollowUpSuccess, getContactActivityFollowUpFail, getContactActivityFollowUpSuccess, getProjectLeadActFail, getProjectLeadActSuccess, getProjectLeadCallLogFail, getProjectLeadCallLogSuccess, getProjectLeadEmailLogFail, getProjectLeadEmailLogSuccess, getProjectLeadFollowUpFail, getProjectLeadFollowUpSuccess, getProjectLeadNoteFail, getProjectLeadNoteSuccess } from "./actions"



function* fetchProjectLeadAllAct({ payload:{ leadId, projectGuid} }) {
  try {
    const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectAllActUrl,leadId, projectGuid, agentId)
    yield put(getProjectLeadActSuccess(response))
  } catch (error) {
    yield put(getProjectLeadActFail(error))
  }
}





function* submitProjectFollowLead({ payload: { followups } }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(postProjectLeadFollowUrl,followups)
    
    yield put(addProjectleadFollowUpSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const agentId = localStorage.getItem("userId");
      const response = yield call(getProjectLeadFollowUrl,followups.refId, followups.activityParentRefGuid, agentId)
      yield put(getProjectLeadFollowUpSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectleadFollowUpFail())
  }
}

function* fetchProjectLeadFollow({ payload:{ leadId, projectGuid} }) {
  try {
     const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectLeadFollowUrl, leadId, projectGuid, agentId)
    
    yield put(getProjectLeadFollowUpSuccess(response))
  } catch (error) {
    yield put(getProjectLeadFollowUpFail(error))
  }
}


function* submitProjectLeadNote({ payload: { notes } }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(PostProjectLeadNoteUrl, notes)
    
    yield put(addProjectLeadNoteSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
       const agentId = localStorage.getItem("userId");
      const response = yield call(getProjectLeadNoteUrl,notes.refId, notes.activityParentRefGuid, agentId)
      yield put(getProjectLeadNoteSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectLeadNoteFail())
  }
}

function* fetchProjectLeadNote({ payload:{ leadId, projectGuid} }) {
  try {
     const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectLeadNoteUrl, leadId, projectGuid, agentId)
    yield put(getProjectLeadNoteSuccess(response))
  } catch (error) {
    yield put(getProjectLeadNoteFail(error))
  }
}


function* submitLeadCalllog({ payload: { calllogs } }) {
 toast.loading("Please wait...")
  try {
    let eLink = '';
    if (calllogs.actionType == 'No Answer') {
      eLink = PostProjectLeadCallLog1Url;
    } else if (calllogs.actionType == 'Left Voicemail') {
      eLink = PostProjectLeadCallLog3Url;
    } else {
      eLink = PostProjectLeadCallLog2Url;
    }

    const response = yield call(eLink, {
      refId: parseInt(calllogs.refId),
      addedDate: calllogs.addedDate,
      remarks: calllogs.remarks,
      addedBy: parseInt(localStorage.getItem("userId")),
      activityParentRefId:parseInt(calllogs.activityParentRefId),
      activityParentRefGuid:calllogs.activityParentRefGuid
    })
    yield put(addProjectLeadCallLogSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
       const agentId = localStorage.getItem("userId");
      const response = yield call(getProjectLeadCallLogUrl, calllogs.refId, calllogs.activityParentRefGuid, agentId)
    yield put(getProjectLeadCallLogSuccess(response))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addProjectLeadCallLogFail('Some Error'))
  }
}


function* fetchProjectLeadCallLog({ payload:{ leadId, projectGuid} }) {
  try {
     const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectLeadCallLogUrl, leadId, projectGuid, agentId)
    yield put(getProjectLeadCallLogSuccess(response))
  } catch (error) {
    yield put(getProjectLeadCallLogFail(error))
  }
}


function* submitLeadEmaillog({ payload: { emaillogs } }) {
  
  toast.loading("Please wait...")
   try {
     let eLink = '';
     if (emaillogs.actionType == 'Email Sent') {
       eLink = PostProjectLeadEmailLog3Url;
     } else if (emaillogs.actionType == 'Email Received') {
       eLink = PostProjectLeadEmailLog3Url;
     } else {
       eLink = PostProjectLeadEmailLog3Url;
     }
 
     const response = yield call(eLink, {
       refId: parseInt(emaillogs.refId),
       addedDate: emaillogs.addedDate,
       remarks: emaillogs.remarks,
       addedBy: parseInt(localStorage.getItem("userId")),
       activityParentRefId:parseInt(emaillogs.activityParentRefId),
       activityParentRefGuid:emaillogs.activityParentRefGuid
     })
     yield put(addProjectLeadEmailLogSuccess(response))
     if (response.success == true) {
       toast.dismiss();
       toast.success("Saved successfully");
       const agentId = localStorage.getItem("userId");
       const response = yield call(getProjectLeadEmailLogUrl, emaillogs.refId, emaillogs.activityParentRefGuid, agentId)
     yield put(getProjectLeadEmailLogSuccess(response))
     } else {
       toast.dismiss();
       toast.warn("Some Error. Please try after some time");
     }
   }
   catch (error) {
 
     yield put(addProjectLeadEmailLogFail('Some Error'))
   }
 }

 function* fetchProjectLeadEmaillLog({ payload:{ leadId, projectGuid} }) {
  try {
    const agentId = localStorage.getItem("userId");
    const response = yield call(getProjectLeadEmailLogUrl, leadId, projectGuid, agentId)
    yield put(getProjectLeadEmailLogSuccess(response))
  } catch (error) {
    yield put(getProjectLeadEmailLogFail(error))
  }
}

function* submitActivityFollow({ payload: { follow } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postActivityFollowUpApi, follow)
    
    yield put(addActivityFollowUpSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const requestData = {
        activityTypeId: [1,2, 3,4, 12],
        agentId: follow.agentId,
        category: follow.category,
        refId: follow.activityRefId,
      };
      const response = yield call(getActivityFollowUpApi, requestData)
      yield put(getActivityFollowUpSuccess(response))
      
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addActivityFollowUpFail())
  }
}

function* fetchProjectLeadActivityFollow({ payload:{ leadId} }) {
  try {
    const requestData = {
      activityTypeId: [1,2,3,4,12],
      agentId: parseInt(localStorage.getItem('userId')),
      category: 3,
      refId: parseInt(leadId),
    };
    
    const response = yield call(getActivityFollowUpApi, requestData)
    yield put(getActivityFollowUpSuccess(response))
  } catch (error) {
    yield put(getActivityFollowUpFail(error))
  }
}

function* submitContactActivityFollow({ payload: { follow } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postContactActivityFollowUpApi, follow)
    
    yield put(addActivityFollowUpSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const requestData = {
        activityTypeId: [1,2,3,4, 12],
        agentId: follow.agentId,
        category: follow.category,
        refId: follow.activityRefId,
      };
      const response = yield call(getContactActivityFollowUpApi, requestData)
      yield put(getContactActivityFollowUpSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addContactActivityFollowUpFail())
  }
}
function* fetchContactLeadActivityFollow({ payload:{ leadId} }) {
  try {
    const requestData = {
      activityTypeId: [1,2,3,4,12],
      agentId: parseInt(localStorage.getItem('userId')),
      category: 4,
      refId: parseInt(leadId),
    };
    
    const response = yield call(getContactActivityFollowUpApi, requestData)
    yield put(getContactActivityFollowUpSuccess(response))
  } catch (error) {
    yield put(getContactActivityFollowUpFail(error))
  }
}


function* submitActivityProjectFollow({ payload: { follow } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postActivityProjectFollowUpApi, follow)
    
    yield put(addActivityProjectFollowUpSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const requestData = {
        activityTypeId: [1,3,4,12, 2],
        agentId: follow.agentId,
        category: follow.category,
        refId: follow.activityRefId,
        projectGuid: follow.activityParentRefGuid,
        
      };
      const response = yield call(getActivityProjectFollowUpApi, requestData)
      yield put(getActivityProjectFollowUpSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addActivityFollowUpFail())
  }
}

function* fetchActivityProjectLeadFollow({ payload:{ leadId, projectGuid} } ) {
  //
  try {
    const requestData = {
      activityTypeId: [1,3,4,12, 2],
      agentId: parseInt(localStorage.getItem('userId')),
      category: 3,
      refId: parseInt(leadId),
      projectGuid: projectGuid,
      
    };
    
    const response = yield call(getActivityProjectFollowUpApi, requestData)
    yield put(getActivityProjectFollowUpSuccess(response))
  } catch (error) {
    yield put(getActivityProjectFollowUpFail(error))
  }
}


function* projectleadSaga() {
     yield takeEvery(GET_PROJECT_LEAD_ALL_ACT, fetchProjectLeadAllAct)
     yield takeEvery(ADD_PROJECT_LEAD_FOLLOW, submitProjectFollowLead)
     yield takeEvery(GET_PROJECT_LEAD_FOLLOW, fetchProjectLeadFollow)

     yield takeEvery(ADD_PROJECT_LEAD_NOTE, submitProjectLeadNote)
     yield takeEvery(GET_PROJECT_LEAD_NOTE, fetchProjectLeadNote)

     yield takeEvery(ADD_PROJECT_LEAD_CALLLOG, submitLeadCalllog)
     yield takeEvery(GET_PROJECT_LEAD_CALLLOG, fetchProjectLeadCallLog)

     yield takeEvery(ADD_PROJECT_LEAD_EMAILLOG, submitLeadEmaillog)
     yield takeEvery(GET_PROJECT_LEAD_EMAILLOG, fetchProjectLeadEmaillLog)

     yield takeEvery(ADD_ACTIVITY_FOLLOW_UP, submitActivityFollow)
     yield takeEvery(GET_ACTIVITY_FOLLOW_UP, fetchProjectLeadActivityFollow)

     yield takeEvery(ADD_ACTIVITY_PROJECT_FOLLOW_UP, submitActivityProjectFollow)
     yield takeEvery(GET_ACTIVITY_PROJECT_FOLLOW_UP, fetchActivityProjectLeadFollow)

     yield takeEvery(ADD_CONTACT_ACTIVITY_FOLLOW_UP, submitContactActivityFollow)
    
     yield takeEvery(GET_CONTACT_ACTIVITY_FOLLOW_UP, fetchContactLeadActivityFollow)
}


export default projectleadSaga
